/**
 * `classroom-activity#[unitId?]#[examConfigId]`
 */
export const formatClassroomActivityKey = (
  classroomId: string,
  examConfigId: string,
  unitId?: string,
) => {
  const parts = [`classroom-activity`, unitId, examConfigId];

  return {
    id: classroomId,
    sk: parts.join("#"),
  };
};
